var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTechPattern4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 204.12 90.83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;stroke-miterlimit:10;stroke-width:0.63px;}.cls-1{stroke:#fff;}.cls-2{stroke:#9e9c9d;}.cls-3{fill:#9e9c9d;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ex_2",
    "data-name": "ex 2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.46,15.58a2.49,2.49,0,0,1,.35,1.27,2.54,2.54,0,0,1-2.54,2.53h0V16.85Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M203.81,45.49a2.4,2.4,0,0,1-.29,1.16.6.6,0,0,1-.06.11l-2.21-1.27V43h0A2.54,2.54,0,0,1,203.81,45.49Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "201.25 16.85 201.25 45.49 199.06 46.75 178.59 58.57 176.56 59.74 176.45 59.81 174.18 58.5 153.85 46.76 151.65 45.49 151.65 16.85 153.85 15.58 174.2 3.83 176.45 2.53 178.59 3.76 199.06 15.59 201.25 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "102.04 16.85 102.04 45.49 126.84 59.81 151.64 45.49 151.64 16.85 126.84 2.53 102.04 16.85"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.44 16.85 52.44 45.49 50.25 46.75 29.8 58.56 27.75 59.74 27.63 59.81 25.36 58.51 5.04 46.76 2.83 45.49 2.83 16.85 5.04 15.58 27.63 2.53 50.25 15.59 52.44 16.85"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.83,16.85v2.53A2.54,2.54,0,0,1,.65,15.59Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M2.83,43v2.53L.65,46.75h0a2.61,2.61,0,0,1-.32-1.25A2.53,2.53,0,0,1,2.83,43Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.43 16.85 52.43 45.49 77.23 59.81 102.04 45.49 102.04 16.85 77.23 2.53 52.43 16.85"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "176.57 88.37 176.57 85.77 176.57 62.29 176.57 59.74 176.57 59.73 178.6 58.56 199.07 46.74 201.25 45.48 201.37 45.41 203.52 46.65"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "176.56 88.38 176.56 59.74 151.76 45.42 126.95 59.74"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "77.35 88.38 77.35 59.74 52.55 45.42 27.74 59.74 27.74 88.38"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "0.64 46.74 2.83 45.47 2.94 45.41 5.1 46.66 25.44 58.4 27.75 59.73 27.75 59.74 27.75 62.29 27.75 85.77 27.75 88.37"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "126.95 59.74 102.15 45.42 77.35 59.74 77.35 88.38"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27.57,
    cy: 59.77,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 77.17,
    cy: 59.77,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 126.77,
    cy: 59.77,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 176.37,
    cy: 59.77,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27.57,
    cy: 88.3,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 77.17,
    cy: 88.3,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 27.57,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 77.17,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 176.37,
    cy: 88.3,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 176.37,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 126.95,
    cy: 2.53,
    r: 2.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.38,45.49a2.56,2.56,0,0,1-.28,1.17l-.06.1a2.54,2.54,0,0,1-4.39,0h0a2.61,2.61,0,0,1-.32-1.25A2.53,2.53,0,0,1,2.83,43h0A2.53,2.53,0,0,1,5.38,45.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M5.38,16.85a2.53,2.53,0,0,1-2.53,2.53h0A2.53,2.53,0,1,1,5,15.58,2.49,2.49,0,0,1,5.38,16.85Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 52.45,
    cy: 45.49,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 52.45,
    cy: 16.85,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 102.06,
    cy: 45.49,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 102.06,
    cy: 16.85,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 151.66,
    cy: 45.49,
    r: 2.53
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 151.66,
    cy: 16.85,
    r: 2.53
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.81,45.49a2.4,2.4,0,0,1-.29,1.16.6.6,0,0,1-.06.11,2.54,2.54,0,0,1-4.39,0h0A2.53,2.53,0,0,1,201.25,43h0A2.54,2.54,0,0,1,203.81,45.49Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M203.81,16.85a2.54,2.54,0,0,1-2.54,2.53h0a2.53,2.53,0,1,1,2.21-3.8A2.49,2.49,0,0,1,203.81,16.85Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTechPattern4);
export default __webpack_public_path__ + "static/media/tech-pattern-4.d6faca994d3101022c9b5630b7d8ea26.svg";
export { ForwardRef as ReactComponent };